// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "59bd1a5ed0c72acf5def9d48c408c8fa" + ".js";
};